import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import dayjs from "dayjs";
import { Button } from "antd";
import { CommentOutlined, EyeOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationArrow } from '@fortawesome/free-solid-svg-icons/faLocationArrow';
import ConsignmentStatusText from '../consignments/ConsignmentStatusText';
import DriverChatModal from '../../components/DriverChatModal';
import { InfoWindow } from '../../components/googleMap';
import { useApiIsLoaded } from '@vis.gl/react-google-maps';
import VehicleHireStatusText from "../vehicleHires/VehicleHireStatusText";
import { userHasPermission } from "../../../../swzutils/UserPermissionsUtil";
import './MapInfoWindow.css';
import { loggedInUserSelector } from "../../../../store/slice/auth";
import { useAppSelector } from "../../../../store";
const DriverLocationInfoWindow = (props) => {
    const [stateChatToDriver, setStateChatToDriver] = useState(null);
    const [stateLocationDescription, setStateLocationDescription] = useState(null);
    const [stateDriverETA, setStateDriverETA] = useState(null);
    const loggedInUser = useAppSelector(loggedInUserSelector);
    const mapsApiLoaded = useApiIsLoaded();
    useEffect(() => {
        if (props.driverLocation && mapsApiLoaded) {
            setStateDriverETA(null);
            setStateLocationDescription(null);
            determineDriverLocation(props.driverLocation);
        }
    }, [props.driverLocation, mapsApiLoaded]);
    // TODO
    // componentDidUpdate(prevProps, prevState, snapshot) {
    //     if (this.props.driverLocation && this.props.google && prevProps.driverLocation !== this.props.driverLocation) {
    //         this.setState({
    //             driverEta: null,
    //             locationDescription: null
    //         });
    //         this.determineDriverLocation(this.props.driverLocation);
    //     }
    //     if (this.props.google && !prevProps.google && this.props.driverLocation) {
    //         this.setState({
    //             driverEta: null,
    //             locationDescription: null
    //         });
    //         this.determineDriverLocation(this.props.driverLocation);
    //     }
    // }
    const showDriverChatModal = (driverSummary) => {
        setStateChatToDriver(driverSummary);
    };
    const hideDriverChatModal = () => {
        setStateChatToDriver(null);
    };
    const determineDriverLocation = (driverLocation) => {
        const deliveryAddr = driverLocation.consignmentSummary && driverLocation.consignmentSummary.deliveryAddress;
        const deliveryHasArrived = driverLocation.consignmentSummary && driverLocation.consignmentSummary.deliveryArrivedAt;
        if (deliveryAddr && deliveryAddr.latitude && deliveryAddr.longitude && !deliveryHasArrived) {
            calcDriverEta(driverLocation);
        }
        else {
            calcDriverLocation(driverLocation);
        }
    };
    const calcDriverEta = (driverLocation) => {
        const deliveryAddr = driverLocation.consignmentSummary?.deliveryAddress;
        if (!deliveryAddr || !deliveryAddr.latitude || !deliveryAddr.longitude) {
            return;
        }
        const driverLatLng = new google.maps.LatLng(driverLocation.latitude, driverLocation.longitude);
        const deliveryLatLng = new google.maps.LatLng(deliveryAddr.latitude, deliveryAddr.longitude);
        const distanceMatrixService = new google.maps.DistanceMatrixService();
        distanceMatrixService.getDistanceMatrix({
            origins: [driverLatLng],
            destinations: [deliveryLatLng],
            travelMode: google.maps.TravelMode.DRIVING,
            unitSystem: google.maps.UnitSystem.METRIC,
            avoidHighways: false,
            avoidTolls: false,
        }, (response, status) => {
            //console.log("response", response);
            //console.log("status", status);
            //console.log("response.rows[0].elements[0].status", response.rows[0].elements[0].status);
            if (response && status === google.maps.DistanceMatrixStatus.OK && response.rows[0].elements[0].status === google.maps.DistanceMatrixElementStatus.OK) {
                const googleCalc = response.rows[0].elements[0];
                const selRecordedAt = dayjs(driverLocation.recordedAt);
                const eta = selRecordedAt.add(googleCalc.duration.value, "seconds");
                let estDurationDesc = " (" + dayjs.duration(dayjs().diff(eta)).humanize();
                estDurationDesc += eta.isBefore() ? " ago)" : " from now)";
                setStateDriverETA({
                    vehicleLocation: response.originAddresses[0],
                    distance: googleCalc.distance.text,
                    duration: googleCalc.duration.text,
                    estArrivalTime: eta.format("HH:mm") + estDurationDesc
                });
            }
            else {
                setStateLocationDescription("Unable to determine ETA");
            }
        });
    };
    const calcDriverLocation = (driverLocation) => {
        if (driverLocation.latitude && driverLocation.longitude) {
            const driverLatLng = new google.maps.LatLng(driverLocation.latitude, driverLocation.longitude);
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({ 'location': driverLatLng }, (response, status) => {
                //console.log("response", response);
                //console.log("status", status);
                if (status === google.maps.GeocoderStatus.OK && response && response.length > 0) {
                    setStateLocationDescription(response[0].formatted_address);
                }
            });
        }
    };
    const now = dayjs();
    const dl = props.driverLocation;
    const recordedAt = dl && dayjs(dl.recordedAt);
    const idleTime = dl && dl.idleSeconds && dayjs.duration(dl.idleSeconds, 'seconds').format('H:mm:ss');
    const canViewVehicleDeliveries = userHasPermission(loggedInUser, ['admin:vehicle:deliveries']);
    const iconButtonStyle = {
        'minWidth': '45px'
    };
    return (_jsx(InfoWindow, { marker: props.markerRef?.current, visible: props.visible, onClose: props.onClose, children: _jsxs(_Fragment, { children: [dl ?
                    _jsxs("div", { className: "map-info-window", children: [dl.driverSummary &&
                                _jsx("div", { className: "segment clearfix", children: _jsxs("h4", { children: [canViewVehicleDeliveries &&
                                                _jsx(Button, { className: "pull-right", style: iconButtonStyle, onClick: () => showDriverChatModal(dl.driverSummary), title: "Message Driver", icon: _jsx(CommentOutlined, {}) }), dl.driverSummary.firstName, "\u00A0", dl.driverSummary.lastName, _jsx("br", {}), dl.driverSummary.tenantName] }) }), dl.vehicle && dl.vehicle.registration &&
                                _jsx("div", { className: "segment clearfix", children: _jsxs("p", { children: [canViewVehicleDeliveries &&
                                                _jsx(Button, { className: "pull-right", style: iconButtonStyle, href: "#/app/map/vehicle-route/" + dl.vehicle.id, title: "Vehicle Route", icon: _jsx(FontAwesomeIcon, { icon: faLocationArrow }) }), dl.vehicle.registration, " - ", dl.vehicle.type.description, _jsx("br", {}), dl.driverSummary.mobileNo] }) }), dl.vehicle && !dl.vehicle.registration &&
                                _jsx("p", { children: dl.vehicle.type.description }), (dl.consignmentSummary && props.showConsignmentSummary) &&
                                _jsxs("div", { className: "segment clearfix", children: [_jsx(Button, { className: "pull-right", style: iconButtonStyle, href: "#/app/consignments/view/" + dl.consignmentSummary.id, title: "View Delivery", icon: _jsx(EyeOutlined, {}) }), "Consignment Ref: ", dl.consignmentSummary.consignmentRef, _jsx("br", {}), dl.consignmentSummary.customer && _jsxs("span", { children: ["Name: ", dl.consignmentSummary.customer.name, _jsx("br", {})] }), "Delivery: ", dl.consignmentSummary.deliveryAddress.unitOrFlat, " ", dl.consignmentSummary.deliveryAddress.street, " ", dl.consignmentSummary.deliveryAddress.suburb, _jsx("br", {}), _jsx(ConsignmentStatusText, { consignment: dl.consignmentSummary })] }), dl.vehicleHireSummary && props.showVehicleHireSummary &&
                                _jsxs("div", { className: "segment clearfix", children: [_jsx(Button, { className: "pull-right", style: iconButtonStyle, href: "#/app/vehicle-hires/edit/" + dl.vehicleHireSummary.id, title: "View Vehicle Request", icon: _jsx(EyeOutlined, {}) }), "Pay by the ", dl.vehicleHireSummary.paymentMethod, " - ", dl.vehicleHireSummary.ref, _jsx("br", {}), dl.vehicleHireSummary.customer && _jsxs("span", { children: ["Name: ", dl.vehicleHireSummary.customer.name, _jsx("br", {})] }), _jsx(VehicleHireStatusText, { vehicleHire: dl.vehicleHireSummary })] }), stateDriverETA &&
                                _jsxs("div", { className: "segment clearfix", children: ["Location: ", stateDriverETA.vehicleLocation, _jsx("br", {}), "Distance: ", stateDriverETA.distance, _jsx("br", {}), "Travel Time: ", stateDriverETA.duration, _jsx("br", {}), "Actual ETA: ", stateDriverETA.estArrivalTime] }), stateLocationDescription &&
                                _jsxs("div", { className: "segment clearfix", children: ["Location: ", stateLocationDescription] }), _jsxs("p", { children: ["Recorded At: ", recordedAt?.format("HH:mm"), "  (", dayjs.duration(now.diff(recordedAt)).humanize(), " ago)", idleTime ? _jsxs("span", { children: [_jsx("br", {}), "Idle Time: ", idleTime] }) : null] })] }) : _jsx("div", {}), _jsx(DriverChatModal, { open: stateChatToDriver != null, onClose: hideDriverChatModal, driver: stateChatToDriver })] }) }, "DriverLocationInfoWindow"));
};
export default DriverLocationInfoWindow;
